/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { type ContextValue, TabList as TabListCore, type TabListProps as TabListCoreProps, useContextProps } from 'react-aria-components';
import { breakpoints } from '../../constants.stylex';

interface TabListProps<T> extends Omit<TabListCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const TabListContext = createContext<ContextValue<TabListProps<object>, HTMLDivElement>>({});

const TabList = forwardRef((props: TabListProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TabListContext);

  const { style, children, ...coreProps } = props;

  return (
    <TabListCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </TabListCore>
  );
}) as <T extends object>(p: TabListProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    display: 'flex',
    flexDirection: {
      default: 'row',
      ':is([data-orientation="vertical"])': 'column'
    },
    gap: {
      default: 40,
      [breakpoints.small]: 24,
    },
  },
});

export { TabList, TabListContext, type TabListProps };
